import React, { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';
import { CookiesProvider } from 'react-cookie';
import { Helmet } from 'react-helmet';
import { Script } from 'gatsby';

import { StickyWidget } from '@components';
import favicon from '@images/favicon-embiq.svg';
import { gtagScript } from '@utils/gtag';
import { chatStyles } from '@utils/chatStyles';
import { linkedInScript } from '@utils/linkedInScript';
import useTimeout from '@utils/hooks/useTimeout';
import { pipedriveScript } from '@utils/pipedriveScript';

import { Footer } from '../Footer/Footer';
import { Navigation } from '../Navigation/Navigation';
import { Cookies } from '../Cookies/Cookies';

export const DefaultLayout: React.FC<DefaultLayoutProps> = ({
	children,
	scheme,
}) => {
	const loadScripts = useTimeout(5000);
	return (
		<>
			<Helmet
				defaultTitle="EMBIQ The Beauty of Innovation &#38; Quality"
				htmlAttributes={{
					lang: 'en',
				}}
			>
				<Script
					src="https://www.googletagmanager.com/gtag/js?id=UA-35459827-1"
					strategy="off-main-thread"
					forward={[`dataLayer.push`]}
				/>
				<Script id="gtag-config" strategy="off-main-thread" forward={[`gtag`]}>
					{gtagScript}
				</Script>
				<Script id="linkedIn-analytics">{linkedInScript}</Script>
				{loadScripts && <script defer>{pipedriveScript}</script>}
				<noscript>
					{`<img
						height="1"
						width="1"
						style={{ display: 'none' }}
						alt="Linkedin gif"
						src="https://px.ads.linkedin.com/collect/?pid=4607929&fmt=gif"
					/>`}
				</noscript>
				<link rel="icon" type="image/png" href={favicon} />
				<link
					rel="mask-icon"
					href="/images/icons/safari-pinned-tab.svg"
					color="#e7732b"
				/>
				<meta name="msapplication-TileColor" content="#2b5797" />
				<meta httpEquiv="Cache-control" content="public" />
			</Helmet>
			<CookiesProvider>
				{loadScripts && <StickyWidget />}
				<Cookies />
				<Navigation scheme={scheme} />
				{children}
				<Footer />
			</CookiesProvider>
			<style>{chatStyles}</style>
		</>
	);
};

interface DefaultLayoutProps
	extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	children: ReactNode;
	scheme: 'light' | 'dark' | 'light-blog';
}
